import * as tslib_1 from "tslib";
import { OWA_AUTO_LINKS_CLASSNAME, X_OWA_AUTO_LINKS_CLASSNAME } from './trySetIdAndClassName';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { format } from 'owa-strings';
import { trace } from 'owa-trace';
import { lazyDidCanNotShareLinkIdsChange, lazyUpdateInfoBar, } from 'owa-attachment-well-data';
export default function getAllSharePointLinks(editor, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var existingLinkIdMap, didCanNotShareLinkIdsChange, updateInfoBar;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
                        return [2 /*return*/];
                    }
                    existingLinkIdMap = {};
                    getLinksBasedOnClassName(OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
                    getLinksBasedOnClassName(X_OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
                    return [4 /*yield*/, lazyDidCanNotShareLinkIdsChange.import()];
                case 1:
                    didCanNotShareLinkIdsChange = _a.sent();
                    if (!didCanNotShareLinkIdsChange(viewState, existingLinkIdMap)) return [3 /*break*/, 3];
                    logUsage(datapoints.AttachmentComposeSPLinkRemove.datapoint.name);
                    return [4 /*yield*/, lazyUpdateInfoBar.import()];
                case 2:
                    updateInfoBar = _a.sent();
                    updateInfoBar(viewState, parentItemIdWrapper.itemId, infoBarAddHandler, infoBarRemoveHandler);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getLinksBasedOnClassName(className, editor, existingLinkIdMap) {
    var allSPLinks = editor.queryContent('.' + className);
    for (var i = 0; i < allSPLinks.length; i++) {
        var link = allSPLinks[i];
        existingLinkIdMap[link.id] = true;
    }
    trace.info(format('getLinksBasedOnClassName: Found {0} SP links.', allSPLinks.length));
}
//# sourceMappingURL=getAllSharePointLinks.js.map